import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import DisplayPlotlyGraph from "../replot/DisplayPlotlyGrapgh";
import { useMediaQuery } from "react-responsive";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const PlotlyGraph = ({
  graph,
  messageID,
  childId,
  version,
  AnswerDisplay,
  tableCoumn,
  setResponceData,
  responceData,
  setGraphDataNew
}) => {
  const [GraphData, setGraphData] = useState(graph);
  const [openPlotly, setOpenPlotly] = useState(false);
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  
  
  
  // useEffect(() => {
  //   if(graphData){
  //     const graphData = JSON.parse(GraphData);
  //     setGraphDataNew(graphData);
  //   }
  // }, [GraphData]);


  // Handle empty graph
  if (Object.keys(GraphData).length === 0) {
    return <div style={{ display: "none" }}></div>;
  }


  const graphData = JSON.parse(GraphData);
  const headers = tableCoumn && Object.keys(tableCoumn);

  

  // Layout adjustments for responsive
  let layoutData = {};
  if (isTab) {
    layoutData = {
      ...graphData.layout,
      legend: {
        orientation: "h",
        xanchor: "center",
      },
    };
  } else {
    layoutData = {
      ...graphData.layout,
      plot_bgcolor: "transparent",   // chart area
      paper_bgcolor: "transparent",  // outer background
      autosize: true,
      hovermode: false,
      margin: { t: 70, l: 30, r: 30, b: 30 },
      legend: {
        x: 1.2,
      },
    };
  }

  // console.log("responceData: ", responceData);
  // console.log("GraphData: ", GraphData);
  // console.log("messageID: ", messageID);

 




  return (
    <div className="relative rounded-lg p-8 border border-gray-300 bg-gray-100">
      {/* Expand Icon */}
      <div
        className="absolute top-3 right-3 cursor-pointer z-10 bg-white p-1 rounded-full shadow hideClass"
        onClick={() => setOpenPlotly(true)}
      >
        <OpenInFullIcon fontSize="small" />
      </div>

      {/* Chart */}
      <div className="relative">
        <Plot
          data={graphData.data}
          layout={layoutData}
          useResizeHandler={true}
          style={{ width: "100%",height:"100%" }}
          config={{
            displaylogo: false,
            responsive: true,
            displayModeBar: false,
            modeBarButtonsToRemove: [
              "hoverCompareCartesian",
              "hoverClosestCartesian",
            ],
          }}
        />
      </div>

      {/* Controls below chart */}
      {!AnswerDisplay && (
        <DisplayPlotlyGraph
          setGraphData={setGraphData}
          messageID={messageID}
          childId={childId}
          version={version}
          AnswerDisplay={AnswerDisplay}
          headers={headers}
          setGraphDataNew = {graphData}
        />
      )}

      {/* Fullscreen Popup */}
      {openPlotly && (
        <Dialog
          open={openPlotly}
          keepMounted
          onClose={() => setOpenPlotly(false)}
          aria-describedby="alert-dialog-slide-description"
          id="plotly-popup"
          maxWidth="lg"
          fullWidth
        >
          {isTab && (
            <IconButton
              onClick={() => setOpenPlotly(false)}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 1,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
          <DialogContent>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
              className="plotly-cont"
            >
              <Plot
                className="mobile-layout-graph"
                data={graphData.data}
                layout={layoutData}
                style={{ width: "100%", height: "100%",minHeight: "400px" }}
                config={{
                  displaylogo: false,
                  responsive: true,
                  displayModeBar: false,
                  modeBarButtonsToRemove: [
                    "hoverCompareCartesian",
                    "hoverClosestCartesian",
                  ],
                }}
              />

              {!AnswerDisplay && (
                <DisplayPlotlyGraph
                  setGraphData={setGraphData}
                  messageID={messageID}
                  childId={childId}
                  version={version}
                  AnswerDisplay={AnswerDisplay}
                  headers={headers}
                  setGraphDataNew={graphData}
                />
              )}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default PlotlyGraph;
